import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Collapse } from 'react-collapse';
import { Field, FormSection, touch } from 'redux-form/immutable';
import Loading from '../../../../components/Loading/index';
import { Map } from 'immutable';
import fieldsConfig from './fieldsConfig';
import './style.scss';
import Fias from '../../../../components/FIAS';
import fiasFormFields from '../../../../components/FIAS/constants/formFields';
import { filter, get } from 'lodash';
import Link from 'containers/LinkWrapperContainer';
import { routeMap } from '../../../../router';
import { remotePaths } from 'router/routes';

export default class PersonalInfoGP3 extends Component {
  static propTypes = {
    needAutofill: PropTypes.bool,
    fields: PropTypes.array,
    autofill: PropTypes.func.isRequired,
    personalInfo: PropTypes.instanceOf(Map).isRequired,
    user: PropTypes.instanceOf(Map).isRequired,
    documentTypes: PropTypes.instanceOf(Map).isRequired,
    formErrors: PropTypes.object,
    isDisabledForm: PropTypes.bool,
    contactInfo: PropTypes.instanceOf(Map).isRequired,
    isOpen: PropTypes.bool,
    hasFiasParsedAddress: PropTypes.bool,
    fiasAddress: PropTypes.instanceOf(Map),
    fiasFieldsConfig: PropTypes.object,
    parentFormName: PropTypes.string.isRequired,
    /**
     * Full path to personal data object in redux from parentFormName
     */
    parentName: PropTypes.string,
    fiasParentName: PropTypes.string,
    form: PropTypes.instanceOf(Map).isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  static defaultProps = {
    needAutofill: true,
    fields: [
      fieldsConfig.inn,
      fieldsConfig.lastName,
      fieldsConfig.firstName,
      fieldsConfig.middleName,
      fieldsConfig.documentTypes,
      fieldsConfig.documentNumber,
      fieldsConfig.documentDate,
      fieldsConfig.issuedBy,
    ],
    isDisabledForm: true,
    hasFiasParsedAddress: false,
    parentName: '',
  };

  state = {
    show: false,
    selectedCode: null,
  };

  componentDidMount() {
    if (!this.props.user.getIn(['data', 'inn'])) {
      this.loadUserInfo();
    }

    if (!this.props.personalInfo.get('data')) {
      this.loadPersonalData();
    }

    if (!this.props.documentTypes.get('data')) {
      this.loadDocumentTypes();
    }
    if (!this.props.contactInfo.get('data')) {
      this.loadContactInfo();
    }

    if (!this.isLoading() && this.props.needAutofill) {
      this.autofill();
    }

    this.setSelectedCode(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { formErrors, fields, hasFiasParsedAddress, form, parentFormName } = nextProps;

    this.setSelectedCode(nextProps);

    if (nextProps.isOpen === true) {
      this.setState({ show: true });
    }

    //валидация отныне должна пройти в самом начале
    const data = form.size ? form.get(`${parentFormName}`) : Map({});

    const formSyncErrors = data.get('syncErrors') || formErrors;
    if (!formSyncErrors) {
      return;
    }

    const generalFields = fields.filter((field) => field.validate);
    const fiasFields = filter(fiasFormFields, (field) => field.validate);
    const requiredFields = hasFiasParsedAddress ? [...generalFields, ...fiasFields] : generalFields;

    for (const field of requiredFields) {
      const fieldName = this.getFieldName(field);
      if (get(formSyncErrors, fieldName)) {
        this.setState({ show: true, hasError: true });
        break;
      }
    }

    const hasContactInfoErrors =
      (fields.email && get(formSyncErrors, this.getFieldName(fields.email))) ||
      (fields.phone && get(formSyncErrors, this.getFieldName(fields.phone)));

    if (hasContactInfoErrors) {
      this.setState({ needUpdateContactInfo: true });
    }
  }

  componentDidUpdate(nextProps) {
    if (
      this.isLoading(this.props) ||
      this.isLoading(nextProps) === this.isLoading(this.props) ||
      !this.props.needAutofill
    ) {
      return;
    }

    this.autofill();
  }

  getFieldName = (field) => {
    const { parentName } = this.props;
    return parentName ? `${parentName}.${field.name}` : field.name;
  };

  setSelectedCode = (props) => {
    const { personalInfo, needAutofill, form, parentFormName } = props;
    const dontSetCode = (needAutofill && !personalInfo) || (!needAutofill && !form.size);
    if (dontSetCode) {
      return;
    }
    if (!needAutofill) {
      const documentType = form.get(parentFormName).getIn(['values', 'documentType']);
      this.setState({ selectedCode: documentType });
    } else if (!this.state.selectedCode && personalInfo.get('data')) {
      this.setState({ selectedCode: personalInfo.get('data').code });
    }
  };

  getTitle = () => {
    if (this.isLoading()) {
      return 'Данные налогоплательщика';
    }
    const { form, parentFormName } = this.props;

    //форма дестроится каждый раз, поэтому необязательно передавать название, хранится нужная нам

    const data = form.size ? form.get(parentFormName) : {};

    const personalInfo = this.props.personalInfo.get('data');

    const inn = this.props.user.getIn(['data', 'inn']);
    const lastName = Map.isMap(data) ? data.getIn(['values', 'lastName']) : personalInfo.lastName;
    const firstName = Map.isMap(data)
      ? data.getIn(['values', 'firstName'])
      : personalInfo.firstName;
    const middleName = Map.isMap(data)
      ? data.getIn(['values', 'middleName'])
      : personalInfo.middleName;

    return `Данные налогоплательщика: ${lastName || ''} ${firstName || ''} ${
      middleName || ''
    } ИНН ${inn}`;
  };

  needUpdateDataBlock = () => {
    if (!this.state.hasError) {
      return null;
    }
    return (
      <div>
        <div className="page_margin30">
          <Link href={routeMap.updatePersonalData}>Уточните персональные данные</Link>
        </div>
        {this.state.needUpdateContactInfo ? (
          <div className="page_margin30">
            <a href={remotePaths.profile}>Уточните контактную информацию</a>
          </div>
        ) : null}
      </div>
    );
  };

  toggleShow() {
    if (this.isLoading()) {
      return;
    }

    this.setState({ show: !this.state.show });
  }

  isLoading(props = this.props) {
    return (
      !props.personalInfo.get('data') ||
      props.personalInfo.get('loading') ||
      !props.user.get('data') ||
      props.user.get('loading') ||
      !props.documentTypes.get('data') ||
      props.documentTypes.get('loading') ||
      !props.contactInfo.get('data') ||
      props.contactInfo.get('loading')
    );
  }

  autofill() {
    const { fields, dispatch, parentFormName } = this.props;
    fields.forEach((field) => {
      const fieldName = this.getFieldName(field);
      this.props.autofill(fieldName, field.getter(this.props));
      dispatch(touch(parentFormName, [fieldName]));
    });
  }

  loadUserInfo() {}

  loadPersonalData() {}

  loadDocumentTypes() {}

  loadFiasAddress() {}

  renderLoading() {
    return (
      <div className="loading">
        <Loading />
      </div>
    );
  }

  render() {
    const { fields, isDisabledForm, hasFiasParsedAddress } = this.props;
    const fiasInitialValues = Map({});
    if (this.isLoading()) {
      return (
        <div className="gp3-personaldata_container">
          <div className="drop">
            <div
              className={classnames('drop_button__check', { active: this.state.show })}
              onClick={() => this.toggleShow()}
            >
              {!this.state.show ? <div className="drop_icon drop_icon__check" /> : null}
              <div className="drop_title">
                <span className="bold">{this.getTitle()}</span>
              </div>
              {this.renderLoading()}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="gp3-personaldata_container">
        <div className="drop">
          <div
            className={classnames('drop_button__check', { active: this.state.show })}
            onClick={() => this.toggleShow()}
          >
            {!this.state.show ? <div className="drop_icon drop_icon__check" /> : null}
            <div className="drop_title">
              <span className="bold">{this.getTitle()}</span>
            </div>
          </div>
        </div>
        <div
          className={classnames('drop_block', 'drop_block__border', {
            drop_block__hided: !this.state.show,
          })}
        >
          <Collapse isOpened={this.state.show}>
            {this.needUpdateDataBlock()}
            <FormSection name={this.props.parentName}>
              {fields.map((field) => {
                const fieldProps = {
                  key: field.name,
                  ...field,
                };

                if (typeof field.options === 'function') {
                  fieldProps.options = field.options(this.props);
                }

                if (typeof field.disabled === 'function') {
                  fieldProps.isDisabled = isDisabledForm || field.disabled(this.props);
                  field.disabled = field.disabled(this.props);
                } else {
                  fieldProps.isDisabled = isDisabledForm || field.disabled;
                }

                if (field.saveChangesTo) {
                  field.onChange = (e, value) => this.setState({ [field.saveChangesTo]: value });
                }

                if (
                  field.isVisible &&
                  !field.isVisible.check(this.state[field.isVisible.stateField])
                ) {
                  return null;
                }
                if (typeof field.isRequired === 'function') {
                  fieldProps.isRequired = field.isRequired(this.props);
                }

                if (field.validateWrapper && typeof field.validateWrapper === 'function') {
                  fieldProps.validate = field.validateWrapper(this.props);
                }

                if (typeof field.mask === 'function') {
                  fieldProps.mask = field.mask(this.props);
                }

                return <Field {...fieldProps} key={field.name} />;
              })}
            </FormSection>

            {hasFiasParsedAddress ? (
              <div>
                <div className="page_subtitle">Сведения об адресе налогоплательщика</div>
                <Fias
                  autofill={this.props.autofill}
                  parentName={this.props.fiasParentName}
                  isDisabledForm={this.props.isDisabledForm}
                  formFields={this.props.fiasFieldsConfig}
                  initialValues={fiasInitialValues}
                />
              </div>
            ) : null}
          </Collapse>
        </div>
      </div>
    );
  }
}
